<template>
  <div class="confirmed-record">
    <div class="head">
      <el-radio-group
        class="select-tab"
        v-model="selectedTab"
        @change="toUrl"
      >
        <el-radio-button label="索赔登记"></el-radio-button>
        <el-radio-button label="待确认表单"></el-radio-button>
        <el-radio-button label="已确认表单"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
        <div class="top">
          <div class="orther-search">
            <div class="orther-search-title">其他信息项：</div>
            <div class="orther-search-main">
              <div class="orther-search-row">
                <el-form-item label="仓库：" prop="name">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.warehouseId"
                    placeholder="请选择仓库"
                  >
                    <el-option
                      v-for="item in warehouse"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="快递公司：" prop="expressId">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.expressId"
                    placeholder="请选择仓库"
                  >
                    <el-option
                      v-for="item in expressCompanyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="时间：" prop="billDate">
                  <el-date-picker
                    v-model="ruleForm.billDate"
                    type="daterange"
                    class="w230"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </div>
              <div class="orther-search-row">
                <el-form-item label="认责方：" prop="responsibleParty">
                  <el-select
                    class="white"
                    v-model="ruleForm.responsibleParty"
                    placeholder="请选择认责方"
                  >
                    <el-option
                      v-for="item in responsiblePartyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否认责：" prop="isResponsible">
                  <el-select
                    class="white"
                    v-model="ruleForm.isResponsible"
                    placeholder="请选择是否认责"
                  >
                    <el-option
                      v-for="item in isResponsibleList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="foot tbc-foot">
                  <el-button
                    type="primary"
                    class="btn-blue"
                    @click="search"
                    >搜索</el-button
                  >
                  <el-button class="btn-white" @click="cancel('ruleForm')">清空</el-button>
                  <el-button class="btn-white" @click="exportExcel">导出</el-button>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="main">
          <div class="table">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column
                v-for="(item, index) in tableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :show-overflow-tooltip="item.showToolTip"
                :min-width="item.width"
              ></el-table-column>
              <el-table-column
                label="照片"
              >
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="lookImg(scope.row)"
                  >查看</el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="80"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="!scope.row.isCancel"
                    class="btn-text"
                    type="text"
                    @click="nullify(scope.row.id)"
                  >作废</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <pagination-tpl
                :total="total"
                :currentPage="currentPage"
                :pageSize="pageSize"
                @queryChange="queryChange"
              ></pagination-tpl>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 查看图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="522px"
      class="look-img"
      >
      <el-carousel arrow="always" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="(item, index) in images" :key="index">
          <img v-if="!isNothingImg" class="img" :src="item">
          <div v-else class="nothing-container">
            <img class="nothimg-img" :src="item">
          </div>
          <div class="indicator">
            <span class="indicator-high">
              {{ index+1 }}
            </span>/
            <span>
              {{ images.length }}
            </span>
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import Claim from "models/claim";
import Expenses from "models/expenses";
const expenses = new Expenses();
import Logistics from "models/logistics";
const logistics = new Logistics();
import PaginationTpl from "components/base/PaginationTpl";
// const LOGISTICS_PROBLEM_TYPE = {
//     1: '超时未回复',
//     2: '少件',
//     3: '破损',
//     4: '物流异常（丢件）',
//     5: '物流异常（拦截失败）',
//     6: '物流异常（停更）',
//     7: '物流异常（退回）'
// }
const DEAL_METHOD = {
  1: '补发',
  2: '退差价',
  3: '退款',
}
const IS_RESPONSIBLE = {
  1: '是',
  0: '否'
}
const RESPONSIBLE_PARTY = {
  1: '仓库',
  2: '物流',
  3: '无'
}
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      selectedTab: "已确认表单",
      dialogVisible: false,
      warehouse: [],
      expressCompanyList: [],
      customerList: [],
      projectNameList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      images: [],
      isNothingImg: false,
      logisticsProblemTypeList: [],
      tableTitleList: [
        {label: '仓库', prop: 'warehouseName', width: '', showToolTip: false},
        {label: '时间', prop: 'billDate', width: '120', showToolTip: false},
        {label: '快递公司', prop: 'expressName', width: '120', showToolTip: false},
        {label: '操作人', prop: 'operator', width: '120', showToolTip: false},
        {label: '问题分类', prop: 'logisticsProblemsTypeVal', width: '180', showToolTip: false},
        {label: '处理方案', prop: 'dealMethodVal', width: '120', showToolTip: false},
        {label: '订单号', prop: 'orderCode', width: '220', showToolTip: false},
        {label: '快递单号', prop: 'expressCode', width: '220', showToolTip: false},
        {label: '产品名称', prop: 'productName', width: '120', showToolTip: true},
        {label: '数量', prop: 'quantity', width: '100', showToolTip: false},
        {label: '应付金额', prop: 'payableAmount', width: '120', showToolTip: false},
        {label: '物流承担金额', prop: 'carrierBearAmount', width: '120', showToolTip: false},
        {label: '认责方', prop: 'responsibleParty', width: '120', showToolTip: false},
        {label: '是否认责', prop: 'isResponsible', width: '120', showToolTip: false},
        {label: '项目名称', prop: 'projectName', width: '120', showToolTip: true},
        {label: '客户名称', prop: 'customerName', width: '120', showToolTip: false},
        {label: '备注', prop: 'remarks', width: '150', showToolTip: true},
      ],
      ruleForm: {
        warehouseId: '',
        billDate: '',
        expressId: '',
        isResponsible: '',
        responsibleParty: '',
      },
      isResponsibleList: [
        {id:1, name: '是'},
        {id:0, name: '否'},
      ],
      responsiblePartyList: [
        {id:1, name: '仓库'},
        {id:2, name: '物流'},
        {id:3, name: '无'}
      ],
    }
  },

  async created() {
    this.getWarehouse()
    this.getLogisticsList()
    await this.initProblemTypeList(1, true)
    this.initConfirmedecord()
  },

  methods: {
    toUrl(v) {
      if (v === "待确认表单") {
        this.$router.push({
          path: "/service/claim-index/tbc-record",
        });
      } else if(v === "已确认表单") {
        this.$router.push({
          path: "/service/claim-index/confirmed-record",
        });
      } else {
        this.$router.push({
          path: "/service/claim-index/claim-register",
        });
      }
    },
    /* 
      获取问题分类 
      type: true获取所有问题分类数据 false获取当前认责方的问题分类数据
    */
    async initProblemTypeList(responsibleType, type) {
      let res = await Claim.postProblemTypeList(responsibleType)
      if (res.success) {
        let arr = []
        res.result.map(i => {
          let obj = {}
          obj.id = i.id
          obj.name = i.text
          arr.push(obj)
        })
        if (type) {
          if (responsibleType == 1) {
            await this.initProblemTypeList(2, true)
          }
          this.logisticsProblemTypeList = this.logisticsProblemTypeList.concat(arr);
        }
      } else {
        this.$message.error(res.message)
      }
    },
    initConfirmedecord() {
      let beginDate = this.ruleForm.billDate[0]?this.ruleForm.billDate[0]:''
      let endDate = this.ruleForm.billDate[1]?this.ruleForm.billDate[1]:''
      let data = {
        warehouseId: this.ruleForm.warehouseId,
        beginDate,
        endDate,
        expressId: this.ruleForm.expressId,
        responsibleParty: this.ruleForm.responsibleParty,
        isResponsible: this.ruleForm.isResponsible,
        currentPage: this.currentPage
      }
      Claim.getConfirmRecordList(data).then(res => {
        if (res.success) {
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseId = i.warehouseId
            obj.warehouseName = i.warehouseName
            obj.billDate = i.billDate
            obj.expressId = i.expressId
            obj.expressName = i.expressName
            obj.operator = i.operator
            obj.logisticsProblemsType = i.logisticsProblemsType
            this.logisticsProblemTypeList.map(v => {
              if (i.logisticsProblemsType == v.id) {
                obj.logisticsProblemsTypeVal = v.name
              }
            })
            obj.dealMethod = i.dealMethod
            obj.dealMethodVal = DEAL_METHOD[i.dealMethod]
            obj.orderCode = i.orderCode
            obj.expressCode = i.expressCode
            obj.productName = i.productName
            obj.quantity = i.quantity
            obj.involvedAmount = i.involvedAmount
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.images = i.imageList
            obj.isResponsible = IS_RESPONSIBLE[i.isResponsible]
            obj.responsibleParty = RESPONSIBLE_PARTY[i.responsibleParty]
            obj.payableAmount = i.payableAmount
            obj.carrierBearAmount = i.carrierBearAmount
            obj.approvalRemarks = i.approvalRemarks
            obj.remarks = i.remarks
            obj.isCancel = i.isCancel
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 获取仓库数据 */
    getWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    //获取快递公司列表
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.expressCompanyList = arr;
        }
      });
    },
    cancel(formName) {
      this.$refs[formName].resetFields();
    },
    search() {
      this.currentPage = 1;
      this.initConfirmedecord()
    },
    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initConfirmedecord();
    },
    lookImg(row) {
      if (row.images.length > 0) {
        this.images = row.images
        this.isNothingImg = false
      } else {
        let img = require('../../../../assets/images/nothing-img.png')
        this.images = [img]
        this.isNothingImg = true
      }
      this.dialogVisible = true
    },
    /* 作废 */
    nullify(id) {
      let data = {
        claimId: id
      }
      Claim.postNullifyClaimList(data).then(res => {
        if (res.success) {
          this.$message.success('作废成功')
          this.initConfirmedecord()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 导出Excel表格 */
    exportExcel() {
      let beginDate = this.ruleForm.billDate[0]?this.ruleForm.billDate[0]:''
      let endDate = this.ruleForm.billDate[1]?this.ruleForm.billDate[1]:''
      let options = {
        warehouseId: this.ruleForm.warehouseId,
        beginDate,
        endDate,
        expressId: this.ruleForm.expressId,
        responsibleParty: this.ruleForm.responsibleParty,
        isResponsible: this.ruleForm.isResponsible,
      }
      Claim.getGoodsPriceExcel(options).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
  }
}
</script>

<style lang='scss'>
.confirmed-record {
  flex: 1;
  .head {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 400;
    background: #f2f4f8;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .container {
    .top {
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding: 32px 37px 25px 37px;
      background: #fff;
      margin-bottom: 20px;
      border-radius: 8px;
      background: #fff;
      .orther-search {
        display: flex;
        justify-content: flex-start;
        .orther-search-title {
          font-size: 14px;
          line-height: 32px;
          text-align: left;
        }
        .orther-search-main {
          .orther-search-row {
            display: flex;
          }
        }
      }
    }
    .main {
      background: #fff;
      padding: 20px;
      .table {
        min-height: 500px;
        border-radius: 4px;
      }
      .pagination {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .w230 {
    width: 230px;
  }
}
</style>
<style lang="scss">
.confirmed-record {
  .look-img {
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      margin: 0;
      width: 522px;
      height: 522px;
      box-sizing: border-box;
      .el-carousel {
        width: 100%;
        height: 100%;
        .el-carousel__container {
          height: 100%;
          .img,
          .nothing-container {
            width: 100%;
            height: 478px;
          } 
          .nothing-container {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .nothimg-img {
            width: 320px;
            height: 250px;
          }
          .indicator {
            width: 100%;
            height: 44px;
            color: #999;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            .indicator-high {
              color: #333;
            }
          }
        }
      }
    }
  }
  .tbc-foot {
    .el-form-item__content {
      margin-left: 29px !important;
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>